import { MerchantEmailTrigger } from "@redotech/redo-merchant-email-common/merchant-email-trigger";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

export const previewMerchantEmail = {
  name: "previewMerchantEmail" as const,
  input: z.object({
    trigger: createEnum(MerchantEmailTrigger),
    htmlTemplate: z.string(),
    subject: z.string(),
  }),
  output: z.object({ renderedHtml: z.string(), renderedSubject: z.string() }),
};
